import { render, staticRenderFns } from "./InformationEventsEdit.vue?vue&type=template&id=6be4a716&scoped=true"
import script from "./InformationEventsEdit.vue?vue&type=script&lang=js"
export * from "./InformationEventsEdit.vue?vue&type=script&lang=js"
import style0 from "./InformationEventsEdit.vue?vue&type=style&index=0&id=6be4a716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be4a716",
  null
  
)

export default component.exports